import { useState } from "react";
import { Button, Grid, FormControl, InputLabel, Select, MenuItem, TextField } from "@material-ui/core"
import PostAddIcon from '@material-ui/icons/PostAdd'
import HeaderModal from "../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import { useFormik } from "formik"
import * as yup from "yup";
import useApi from "./../../../hooks/useAPI"
// import { useCatPurchase } from "../../../hooks/useCatPurchase"
import { ToastMessage } from "../../../global/ToastMessage"
import { useDispatch } from "react-redux"
import { crearItemExtraAction, obtenerExtrasContratadosAction } from "./../../../ducks/ExtrasContratadosDuck"
import { catTipoCompra } from "../../../constant/catTipoCompra"
import { makeStyles } from "@material-ui/core"
import { offLoadAction, onLoadAnction } from "./../../../ducks/loadDuck"

export const FormularioReservaStyle = makeStyles((theme) => ({
  textField: {
    width: "97%",
    margin: "5px",
    paddingBottom: 0,
    fontWeight: 500,
  },
  textFieldMultiLinea: {
    width: "97%",
    margin: "5px",
    paddingBottom: 0,
    fontWeight: 500,
  },
  formControl: {
    width: "97%",
    margin: "5px",
  },
  containerSpacing: {
    margin: "10px 0",
  },
  modalBotones: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  modalBotonesCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalBoton: {
    margin: "1px 0",
    width: "20%",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "900px",
    margin: "0 auto",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "none",
    boxShadow: theme.shadows[10],
    padding: theme.spacing(1, 2, 1),
    maxWidth: "900px",
    minWidth: "500px",
  },
}))

const validationSchema = yup.object({
    monto: yup
        .number("Ingresa un monto")
        .positive("Monto postivo")
        .required("Monto es requerido"),
})

const initialValues = {
    monto: 0
}

const ModalFormulario = (props) => {
    const {
        idExtra = 0,
        idCuenta = 0,
        idPaquete = 0,
        Referencia = "",
        open = true,
        setOpen = () => { },
        idMoneda = 0
    } = props
    const dispatch = useDispatch()
    const catalogoMoneda = useApi("Catalog/MonedaProveedor")
    // const dataTipoCompra = useCatPurchase({ idPaquete: idPaquete })
    const classes = FormularioReservaStyle()
    const [tipoMoneda, setTipoMoneda] = useState(idMoneda)
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSave(values)
        },
    })
    const onSave = (values) => {
        dispatch(onLoadAnction({message: ''}))
        dispatch(crearItemExtraAction({
            idCuenta: idCuenta,
            idMoneda: tipoMoneda,
            idPaquete: idPaquete,
            MontoProveedor: values.monto,
            IdExtra: idExtra
        })).then(Response => {
          
            dispatch(offLoadAction())
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null;
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null;
            }
            dispatch(obtenerExtrasContratadosAction())
            handleClose()
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });

        })
    }
    const handleClose = () => {
        setOpen(false)
        setTipoMoneda(idMoneda)
        formik.resetForm(initialValues);
    }
    const handleSelecTipoMoneda = (event) => {
        setTipoMoneda(event.target.value)
    }
    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal
                handleClose={handleClose}
                titulo={`Generar Reserva: #${Referencia}`}
            />
            {/* {
                (!dataTipoCompra.nuevoItem) &&
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12}>
                        <div style={{ textAlign: "center" }}>
                            <h2>Aviso!</h2>
                            <p>Para agregar un nuevo item, se tiene que pagar los items actules</p>
                        </div>
                    </Grid>
                </Grid>
            } */}
            {
                (idMoneda === 0) &&
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12}>
                        <div style={{ textAlign: "center" }}>
                            <h2>Aviso!</h2>
                            <p>Este paquete no tiene moneda proveedor</p>
                        </div>
                    </Grid>
                </Grid>
            }
            {
                // (dataTipoCompra.nuevoItem && idMoneda !== 0) &&
                (idMoneda !== 0) &&
                <form onSubmit={formik.handleSubmit}>
                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={12}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="lTipoMoneda">Moneda</InputLabel>
                                <Select
                                    labelId="lTipoMoneda"
                                    id="STipoMoneda"
                                    name="tipoMoneda"
                                    value={tipoMoneda}
                                    defaultValue={idMoneda}
                                    onChange={handleSelecTipoMoneda}
                                    label="Moneda"
                                    disabled
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {catalogoMoneda.map((moneda, index) => (
                                        <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                                            {`${moneda.Clave} - ${moneda.Descripcion}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="input-Monto"
                                label="Monto"
                                type="text"
                                variant="outlined"
                                name="monto"
                                value={formik.values.monto}
                                onChange={formik.handleChange}
                                error={formik.touched.monto && Boolean(formik.errors.monto)}
                                helperText={formik.touched.monto && formik.errors.monto}
                                className={classes.textField}
                            />
                        </Grid>
                    </Grid>
                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={12} className={classes.modalBotonesCenter}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.modalBoton}
                            >
                                Guardar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            }
        </ModalBase>
    )
}

const FItemExtra = (props) => {
    const { idCuenta, idPaquete, Referencia, idMoneda, disabled = false, idExtra } = props
    const [open, setOpen] = useState(false)
    const onClick = () => {
        setOpen(true)
    }
    return (
        <div>
            <Button variant="outlined" color="primary" onClick={onClick} endIcon={<PostAddIcon />} disabled={disabled}>
                Reservar
            </Button>
            <ModalFormulario
                idCuenta={idCuenta}
                idPaquete={idPaquete}
                Referencia={Referencia}
                idMoneda={idMoneda}
                idExtra={idExtra}
                open={open}
                setOpen={setOpen}
            />
        </div>
    )
}
export default FItemExtra